import React, { createContext, useContext } from 'react';
import { OptionTypeEnum } from 'src/components/filter-dropdown';
import { IPriceRowContext } from './price-row/types';

const initialValue: IPriceRowContext = {
  isFeatured: false,
  offer: {
    featured: false,
    authorizedDealer: false,
    isInternationalPrice: false,
  },
  productId: -1,
  showExpandButton: true,
  showUnfeaturedHideButton: false,
  setShowUnfeaturedPlaceholder: undefined,
  sorting: OptionTypeEnum.CHEAPEST_PRICE,
};
const PriceRowContext = createContext<IPriceRowContext>(initialValue);

export const usePriceRowContext = () => useContext(PriceRowContext);

export const PriceRowContextContainer: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceRowContext>
>> = props => {
  return (
    <PriceRowContext.Provider value={props}>
      {props.children}
    </PriceRowContext.Provider>
  );
};
